import React, { useEffect } from "react";
import { useUtilityAdminTranslation } from "../../../../hooks/useUtilityAdminTranslation";
import { useConfigLayout } from "../../../../hooks/useConfigLayout";
import { FeatureFlagName } from "../../../../tenant/features/featureFlags";
import { useFeatureFlag } from "../../../../tenant/features/useFeatureFlag";
import UtilityPageLayout from "../../component/layout/UtilityPageLayout";
import RefundsList from "./RefundsList";

/** Utility admin → Bills Payment & Operations → Refunds: the auto-refund tracking dashboard. */
const RefundsPage: React.FC = () => {
	const { t } = useUtilityAdminTranslation();
	const { updateLayout } = useConfigLayout();
	const refundsEnabled = useFeatureFlag(FeatureFlagName.ADMIN_REFUNDS);

	useEffect(() => {
		updateLayout({
			showCountrySelector: false,
			utility: null,
			// Nothing to export while the feature is locked.
			showExportButton: refundsEnabled,
			showBreadCrumb: false,
			pageTitle: null,
		});
	}, [updateLayout, refundsEnabled]);

	return (
		<UtilityPageLayout title={t("refunds.title")} feature={FeatureFlagName.ADMIN_REFUNDS}>
			<RefundsList />
		</UtilityPageLayout>
	);
};

export default RefundsPage;
